import React, {useCallback, useContext} from "react";
import {useParams} from "react-router-dom";
import {Card} from "antd";
import {isEmpty} from "lodash";
import "../briefs.css";
import {ProviderBriefDetailsView} from "./ProviderBriefDetailsView.jsx";
import {useRequest} from "../../utils/hooks.jsx";
import {AppContext} from "../../AppContext";
import {createBid, updateBid} from "../../api/bids/bids.js";
import {useHistory} from "react-router-dom";
import {BidStatus} from "../../company/CompanyAccountProfile/CompanyBriefs/consts.jsx";
import {useLocation} from "react-router-dom/cjs/react-router-dom.min.js";

export const ProviderBriefCard = () => {
    const {me} = useContext(AppContext);
    const {briefId} = useParams();
    const history = useHistory();
    const location = useLocation();
    const {bidId} = location.state || {};

    const [briefInfo, loadingBrief] = useRequest(`/api/briefs/${briefId}`, "POST", null, [briefId], !!briefId);

    const [bidInfo] = useRequest(`/api/bids/${bidId}`, "POST", null, [bidId], !!bidId, null, {});

    const [bidProduct] = useRequest(`/api/products/bidProduct/${me.userId}`, "GET", null, [me.userId], !!me.userId);

    const onSendBid = useCallback(
        async values => {
            const res = bidId
                ? await updateBid({...values, note: "", status: BidStatus.pending})
                : await createBid(values);

            if (res.error) {
                return;
            } else {
                return history.push(`/dashboard/briefs`);
            }
        },
        [history]
    );

    return (
        <>
            <div className="brief-container">
                <Card
                    className="brief-information-card-container"
                    bordered={false}
                    cover={
                        <div className="brief-information-card">
                            <div className="brief-information-card-top-bar-container">
                                <div className="brief-information-card-top-bar-item">
                                    <span className="title">נפתחה בקשת הצעת מחיר</span>
                                    קיבלנו בקשה מלקוח שיכולה להתאים לבית העסק שלך, נשמח שתעבור על הבריף ותשלח הצעת מחיר
                                </div>
                            </div>
                            <div className="brief-information-card-break-line" />
                            {!isEmpty(briefInfo) ? (
                                <div className="brief-information-card-section">
                                    <ProviderBriefDetailsView
                                        briefInfo={briefInfo}
                                        bidInfo={bidInfo}
                                        loadingBrief={loadingBrief}
                                        providerId={me.userId}
                                        onSendBid={onSendBid}
                                        bidProduct={bidProduct}
                                    />
                                </div>
                            ) : null}
                        </div>
                    }
                />
            </div>
        </>
    );
};
